<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row">
            <div class="flex md3">
              <va-button outline color="info" @click="exportList()"
                >Exporter le publipostage
              </va-button>
            </div>
            <div class="flex md3" v-if="true">
              <va-button outline color="info" @click="exportListAnnuaire()"
                >Exporter le publipostage annuaire
              </va-button>
            </div>
            <div class="flex md6">
              <va-button
                v-for="(element, index) in years"
                :key="index"
                outline
                :color="yearSelected === index ? 'success' : 'info'"
                @click="yearSelected = index"
                >{{ element }}
              </va-button>
            </div>
          </div>
          <div class="flex md12">
            <va-separator />
          </div>
          <div
            class="flex md12"
            v-for="(element, index) in filteredData"
            :key="element.idextraction"
          >
            <div class="row row-inside">
              <div class="flex md3">
                Liste extraite le
                {{ moment(element.extractiondate).format("DD/MM/YYYY") }} à
                {{ moment(element.extractiondate).format("HH:mm") }}
              </div>
              <div class="flex md3">
                <p class="greenText">{{ element.nbtotal }} destinataires</p>
                <p>
                  {{ element.nbentreprises }} entreprises (
                  {{ element.nbadherents }} adhérents)
                </p>
                <p>
                  {{ element.nbtotal }} contacts dans les entreprises ({{
                    element.nbcontactsadherents
                  }}
                  adhérents)
                </p>
                <p>{{ element.nbpartenaires }} partenaires</p>
              </div>
              <div class="flex md3">
                {{ element.prenom + " " + element.nom }}
              </div>
              <div class="flex md3">
                <va-button
                  outline
                  color="success"
                  @click="getExtractionFile(element)"
                  >Télécharger
                </va-button>
                <va-button outline color="success" @click="">+ </va-button>
              </div>
            </div>
            <va-separator />
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { orderBy } from "lodash";

export default {
  data() {
    return {
      extractionList: [],
      moment: moment,
      years: [moment().format("YYYY")],
      yearSelected: null,
      yearDisplayed: 0
    };
  },
  mounted() {
    this.getExtractionList();
  },
  computed: {
    filteredData() {
      let filteredData = this.extractionList;
      filteredData = orderBy(filteredData, "extractiondate", "desc");

      return filteredData.filter(item => {
        let boolcond = true;

        if (
          (this.yearSelected || this.yearSelected == 0) &&
          this.years[this.yearSelected] !==
            moment(item.extractiondate).format("YYYY")
        ) {
          boolcond = false;
        }

        return boolcond;
      });
    }
  },
  methods: {
    displaydate() {
      return moment().format("DD/MM/YYYY");
    },

    async exportListAnnuaire() {
      try {
        let results = await axios.get("/api/journal/exportAnnuaire");

        this.downloadItem(results.data, "Liste annuaire");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l’export");
      }
    },
    async exportList() {
      try {
        let results = await axios.get("/api/journal/export");

        this.getExtractionList();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l’export");
      }
    },
    async getExtractionList() {
      try {
        let results = await axios.get("/api/journal/extractions/list");
        console.log(results.data);
        this.extractionList = results.data.sort(function compare(a, b) {
          var dateA = new Date(a.extractiondate);
          var dateB = new Date(b.extractiondate);
          return dateA - dateB;
        });

        let activeYear = moment(this.extractionList[0].extractiondate).format(
          "YYYY"
        );
        let yearArray = [activeYear];

        for (let ijk = 1; ijk < this.extractionList.length; ijk++) {
          if (
            moment(this.extractionList[ijk].extractiondate).format("YYYY") !==
            activeYear
          ) {
            activeYear = moment(this.extractionList[ijk].extractiondate).format(
              "YYYY"
            );
            yearArray.push(activeYear);
          }
        }
        this.years = yearArray;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération de la liste");
      }
    },
    async getExtractionFile(extraction) {
      try {
        let results = await axios.get("/api/journal/extractions/file", {
          params: { idextraction: extraction.idextraction }
        });
        this.downloadItem(
          results.data,
          moment(extraction.extractiondate).format("YYYYMMDD") +
            " LISTE DE DIFFUSION"
        );
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération du fichier");
      }
    },

    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  }
};
</script>

<style lang="scss">
.greenText {
  font-weight: bold;
  color: $vue-green;
}
</style>
